import { Grid, Typography, makeStyles } from "@material-ui/core";


const useStyles = makeStyles(() => ({

    message: {
        fontSize: '1em',
        color: '#000',
        fontWeight: 'lighter',
    },

    documentItem: {
        fontSize: '0.8em',
        color: '#231F20',
        font: 'Inter',
        fontWeight: 'lighter',
    },

    image: {
        width: '40%',
        display: "block",
        margin: "0 auto"
    },
}));


export default function GuideStep() {

    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            <br/>
                            Bem vindo,
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Você irá iniciar o processo de recadastramento, para isso e necessário que tenha em mãos os seguintes documentos:
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" component="span" className={classes.message}>
                            <p> - Atestado de Capacidade Física e Cognitiva atualizado (modelo em anexo)</p>
                            <p> - RQE – Registro da Especialidade junto ao CRM;</p>
                            <p> - Certidão de Ética atualizada;</p>
                            <p> - Quitação ou Anuidade</p>
                            <p> - Carteira de Vacina atualizada e Covid;</p>
                            <p> - Declaração de Conflito de Interesse atualizada (modelo em anexo)</p>
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" component="span" className={classes.message}>
                            A não realização do recadastramento e dos treinamentos obrigatórios, implicará na inativação do cadastro até a sua regularização.
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" component="span" className={classes.message}>
                            <br/>
                            Em caso de dúvidas entrar em contato com o SAM:
                        </Typography>
                        <Typography variant="body1" component="span" className={classes.message}>
                            <p> São Paulo (11)3394-1000 </p>
                            <p> E-mail: sam@hsl.org.br</p>
                            <p> Brasília (61) 3044-8888</p>
                            <p> E-mail: sambrasilia@hsl.org.br</p>
                            <p> Assistente Virtual - SÂMIA (11) 5305-6856</p>
                        </Typography>
                    </Grid>

                
            </Grid>
        </div>
    )
}